import Cookies from "js-cookie";
import moment from "moment";
import React from "react";
import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InvalidateToken } from "../constants/api-urlConstants";
import instance from "../utils/axiosInstance";

export const TimerValusSet = createContext<any>([]);

export const TimerValusSets = (props: any) => {
  const { children } = props;
  const [closePopupConfirmation, setClosePopupConfirmation] = React.useState(false);
  const [userHeartBeat, setUserHeartBeat] = useState<any>();
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const navigate = useNavigate();

  const InvalidateTokens = () => {
    const USER_API_BASE_URL = `${InvalidateToken}`;
    instance
      .get(USER_API_BASE_URL)
      .then((response) => {
        localStorage.clear();
        navigate("/login");
      })
      .catch((error) => {
        localStorage.clear();
        navigate("/login");
      });
  };
  const timeExit = () => {
    const timeCookie: any = Cookies.get("ic-token-validity");
    const expireTimestamp = moment(timeCookie).unix();
    const currentTimeStamp = Math.floor((new Date()).getTime() / 1000)
    const diffValue = expireTimestamp - currentTimeStamp;
    let timerValue: any
    if (isNaN(diffValue)) {
      timerValue = 0;
      InvalidateTokens();
    } else if (diffValue < 0) {
      timerValue = 0;
      InvalidateTokens();
    } else {
      timerValue = diffValue
    }
    return timerValue;
  };

  return (
    <TimerValusSet.Provider
      value={{
        userHeartBeat,
        setUserHeartBeat,
        timeExit,
        setClosePopupConfirmation,
        closePopupConfirmation,
        showConfirmation, setShowConfirmation, InvalidateTokens
      }}
    >
      {children}
    </TimerValusSet.Provider>
  );
};
